export default {"src":"/_next/static/media/hit.e4ad702e.svg","height":21,"width":20,"blurWidth":0,"blurHeight":0};